import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sidebar-logo-small',
  templateUrl: './sidebar-logo-small.component.html',
  styleUrls: ["./sidebar-logo-small.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainSidebarLogoSmallComponent {}
